import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { BiCheck } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import useStore from "../../../features/store";
import { checkDisscount, payForPro } from "../../../services/proAnalyse";

const ProAnalyseModal = ({ top, left, size, id }: any) => {
  const navigate = useNavigate();
  const { plans, fetchPlans }: any = useStore();
  const [plansData, setPlansData] = useState<any>(plans);
  const [discountCode, setDiscountCode] = useState<any>("");
  const [discountCodeError, setDiscountCodeError] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingCheckDisscount, setLoadingCheckDisscount] =
    useState<boolean>(false);

  useEffect(() => {
    if (!plans) {
      fetchPlans();
    } else {
      setPlansData(plans);
    }
  }, [plans, fetchPlans]);

  const updatePlansHandler = (_id: number, response: any, isValid: boolean) => {
    if (isValid) {
      const updatedPlans = plans.map((plan: any) =>
        plan.id === _id
          ? { ...plan, new_price: response.data.new_amount }
          : plan
      );

      setPlansData(updatedPlans);
    } else {
      const updatedPlans = plans.map((plan: any) =>
        plan.id === _id ? { ...plan, new_price: null } : plan
      );

      setPlansData(updatedPlans);
    }
  };

  const checkDiscountHandler = async (_id: number, _code: string) => {
    if (!_code.trim()) {
      setDiscountCodeError("لطفاً کد تخفیف را وارد کنید");
      toast.error("لطفاً کد تخفیف را وارد کنید");
      return;
    }

    setLoadingCheckDisscount(true);
    setDiscountCodeError("");

    try {
      const response = await checkDisscount(_id, _code);

      if (!response.data?.discont_code_is_valid) {
        toast.error("کد تخفیف معتبر نیست");
        setDiscountCodeError("کد تخفیف معتبر نیست");
        updatePlansHandler(_id, response, false);
      } else {
        toast.success("کد تخفیف اعمال شد");
        updatePlansHandler(_id, response, true);
      }
    } catch (error) {
      toast.error("خطایی رخ داده است، دوباره تلاش کنید");
    } finally {
      setLoadingCheckDisscount(false);
    }
  };

  const submitTestHandler = async (plan: any) => {
    const paymentData = {
      plan_id: plan.id,
      discount_code: discountCode,
      id: id,
    };
    setLoading(true);
    const paymentResponse = await payForPro(paymentData);

    if (paymentResponse?.data?.url) {
      window.location.href = paymentResponse.data.url;
    } else {
      if (!paymentResponse?.data?.url && paymentResponse?.data?.amount === 0) {
        navigate(`/additional-information/${id}`);
      }
    }
  };

  return (
    <div>
      <button
        className={`${
          size ? size : "btn-sm"
        } btn font-[700] font-rokh pt-1 bg-pr_primary text-white border border-white z-[100] hover:bg-pr_blue_dark`}
        onClick={() => {
          //@ts-ignore
          document.getElementById("my_modal_1").showModal();
        }}
      >
        تحلیل پیشرفته
      </button>
      <dialog id="my_modal_1" className="modal">
        <div className="modal-box bg-white">
          <div className="flex items-center justify-between">
            <h3 className="font-rokh font-[900]"> تحلیل پیشرفته </h3>
            <form method="dialog">
              <button className="btn btn-sm rounded-full px-[6px]">
                <IoClose size={20} />
              </button>
            </form>
          </div>
          <div className="flex flex-col items-center justify-between py-6">
            {plansData
              ?.filter((item: any) => item.id === 2)
              .map((plan: any) => (
                <div
                  key={plan.id}
                  className={`relative flex-1 w-full border rounded-xl p-8 border-2 duration-300 opacity-1 hover:border-pr_purple_dark `}
                >
                  <div className="mb-5 border-b pb-1 flex items-center justify-between">
                    <h3 className="font-rokh font-[700] text-lg lg:text-xl">
                      {plan.title}
                    </h3>

                    <div className="flex items-center gap-1">
                      <h6
                        className={`font-rokh  ${
                          (plan?.new_price || plan?.new_price === 0.0) &&
                          plan.id !== 1
                            ? "line-through font-[700]"
                            : "font-[900]"
                        }`}
                      >
                        {plan.price === 0
                          ? "رایگان"
                          : plan.price.toLocaleString()}
                      </h6>

                      {(plan?.new_price || plan?.new_price === 0.0) && (
                        <h5 className="font-rokh font-[900]">
                          {plan.new_price === 0.0
                            ? "رایگان"
                            : plan.new_price.toLocaleString()}
                        </h5>
                      )}

                      {plan.id !== 1 && plan?.new_price !== 0.0 && (
                        <span className="font-rokh font-[500] text-sm">
                          تومان
                        </span>
                      )}
                    </div>
                  </div>
                  <ul>
                    {Object.entries(plan.meta)
                      ?.sort((a, b) => Number(b[1]) - Number(a[1]))
                      ?.map(([title, isActive]) => (
                        <li
                          key={title}
                          className="flex items-center justify-between mb-[10px]"
                        >
                          <span className="text-sm ml-3">{title}</span>
                          {isActive ? (
                            <BiCheck className="text-pr_green_dark" size={20} />
                          ) : (
                            <IoClose className="text-pr_red_dark" size={20} />
                          )}
                        </li>
                      ))}
                  </ul>

                  <div className="mt-10 lg:min-h-[110px] flex flex-col justify-end">
                    {plan.id === 2 && (
                      <div className="flex items-center justify-between">
                        <h6 className="text-sm">کد تخفیف:</h6>
                        <div className="flex flex-col items-center">
                          <div className="flex tems-center">
                            <div className="border rounded-lg overflow-hidden">
                              <input
                                value={discountCode}
                                onChange={(e) =>
                                  setDiscountCode(e.target.value)
                                }
                                type="text"
                                placeholder="کد تخفیف"
                                className="input input-sm max-w-[150px]"
                              />
                            </div>
                            <button
                              disabled={loadingCheckDisscount}
                              className="btn btn-sm mr-1 bg-pr_primary text-white hover:bg-pr_blue_dark"
                              onClick={() =>
                                checkDiscountHandler(plan.id, discountCode)
                              }
                            >
                              {loadingCheckDisscount ? "..." : "اعمال"}
                            </button>
                          </div>
                          {discountCodeError && (
                            <span className="w-full text-xs text-right text-pr_red_dark mt-1">
                              {discountCodeError}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    <button
                      disabled={loading}
                      onClick={() => submitTestHandler(plan)}
                      className="w-full btn bg-pr_primary text-white mt-5 hover:bg-pr_blue_dark"
                    >
                      {loading ? "در حال انتقال به درگاه پرداخت" : "پرداخت"}
                    </button>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </dialog>
    </div>
  );
};

export default ProAnalyseModal;
